var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconHealth48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6598 9.24731C37.5481 9.24731 41.5108 13.1141 41.5108 17.884C41.5108 20.4419 40.3713 22.74 38.5607 24.3214L24.9038 39.1197L11.3938 24.428C9.51114 22.8441 8.31934 20.4999 8.31934 17.884C8.31934 13.1141 12.2821 9.24731 17.1704 9.24731C20.5034 9.24731 23.4061 11.0449 24.9158 13.7008C26.4241 11.0449 29.3268 9.24731 32.6598 9.24731Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 24.5985H20.75L23.75 19.2048L26.75 29.9921L29.75 24.5985H44",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2661 27.5024C41.87 27.5024 43.1703 26.2021 43.1703 24.5981C43.1703 22.9941 41.87 21.6938 40.2661 21.6938C38.6621 21.6938 37.3618 22.9941 37.3618 24.5981C37.3618 26.2021 38.6621 27.5024 40.2661 27.5024Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconHealth48);
export default __webpack_public_path__ + "static/media/pictogramBeaconHealth48.3ecca09522c14eaa6207da757d016ab9.svg";
export { ForwardRef as ReactComponent };